import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { UnitImageStreetViewDialogComponent } from './unit-image-street-view-dialog.component';
import { AgmCoreModule } from '@agm/core';
import { SharedModule } from '../../../shared/shared.module';


@NgModule({
    declarations: [
        UnitImageStreetViewDialogComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        MatDialogModule,
        AgmCoreModule,
    ],
    exports: [
        UnitImageStreetViewDialogComponent,
    ],
    providers: [
    ],
})
export class UnitImageStreetViewDialogModule
{
}
